import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageSquare, ExternalLink } from 'lucide-react';

function ContactPage() {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowPage(true), 200);
    return () => clearTimeout(t);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would send to a backend service
    console.log('Form submitted:', formData);
    alert('Unfortunately this contact form is still under development. Come back later!');
    // 'Thank you for reaching out! We\'ll get back to you soon.'
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className={`min-h-screen bg-gradient-to-b from-amber-50 to-white transition-opacity duration-1000 ${
      showPage ? 'opacity-100' : 'opacity-0'
    }`}>
      {/* Navigation */}
      <nav className="flex items-center justify-between p-6 max-w-6xl mx-auto">
        <Link to="/" className="text-amber-950 font-light text-2xl hover:text-amber-900 transition-colors">
          veyebe
        </Link>
        <Link to="/" className="flex items-center gap-2 text-amber-900 hover:text-amber-950 transition-colors">
          <ArrowLeft size={20} />
          Back
        </Link>
      </nav>

      {/* Content */}
      <div className="max-w-2xl mx-auto px-6 py-12">
        <div className={`mb-12 transition-all duration-1000 delay-100 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <h1 className="text-5xl md:text-6xl font-light text-amber-950 mb-4">Get In Touch</h1>
          <p className="text-xl text-amber-900 font-light">
            We'd love to hear from you. Whether you have feedback, questions, or just want to say hello, reach out.
          </p>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className={`space-y-6 mb-12 p-8 bg-white rounded-lg border border-amber-100 transition-all duration-1000 delay-300 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <div>
            <label className="block text-amber-950 font-light mb-2">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-amber-200 rounded-lg focus:outline-none focus:border-amber-950 bg-amber-50"
              placeholder="Your name"
            />
          </div>
          
          <div>
            <label className="block text-amber-950 font-light mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-amber-200 rounded-lg focus:outline-none focus:border-amber-950 bg-amber-50"
              placeholder="your@email.com"
            />
          </div>
          
          <div>
            <label className="block text-amber-950 font-light mb-2">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              className="w-full px-4 py-2 border border-amber-200 rounded-lg focus:outline-none focus:border-amber-950 bg-amber-50 resize-none"
              placeholder="Your message..."
            />
          </div>
          
          <button
            type="submit"
            className="w-full px-6 py-3 bg-amber-950 text-amber-50 rounded-lg hover:bg-amber-900 transition-colors font-light"
          >
            Send Message
          </button>
        </form>

        {/* Contact Info */}
        {/* <div className={`grid md:grid-cols-2 gap-6 transition-all duration-1000 delay-500 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <div className="p-6 bg-white rounded-lg border border-amber-100">
            <Mail className="w-6 h-6 text-amber-950 mb-3" />
            <h3 className="text-lg font-light text-amber-950 mb-2">Email</h3>
            <a 
              href="mailto:contact@m1nutes.com"
              className="text-amber-900 hover:text-amber-950 transition-colors flex items-center gap-2"
            >
              contact@veyebe.com
              <ExternalLink size={16} />
            </a>
          </div>
          
          <div className="p-6 bg-white rounded-lg border border-amber-100">
            <MessageSquare className="w-6 h-6 text-amber-950 mb-3" />
            <h3 className="text-lg font-light text-amber-950 mb-2">Social</h3>
            <a 
              href="https://instagram.com"
              className="text-amber-900 hover:text-amber-950 transition-colors flex items-center gap-2"
            >
              Follow us on Instagram
              <ExternalLink size={16} />
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ContactPage;
